export default "__VITE_ASSET__BqhuiGml__"